import { WORK_PAGES } from "./work/pages"

/** id -> address and the page it shows */
export const ROUTES: Record<string, { path: string; page: string }> = {
    home: { path: "/", page: "home" },
    // the about: a video played by the scroll
    about: { path: "/about", page: "about" },
    // the feed: a grid of what's been made lately (a prototype)
    feed: { path: "/feed", page: "feed" },
    // the version before: the photo shrinking into a deck of cards
    aboutOld: { path: "/aabout_old", page: "aboutOld" },
    // the same, flying the camera into the deck instead of closing it
    about2: { path: "/aabout2", page: "about2" },
    // every work page at its own address (src/work/pages.ts)
    ...Object.fromEntries(Object.values(WORK_PAGES).map((p) => [p.id, { path: p.path, page: p.id }])),
}
/** old addresses (from the Framer site) -> route id; the address bar is corrected */
export const ALIASES: Record<string, string> = {
    "/27-home": "home",
    "/27-work": "sports",
    // (where the about was while it was made)
    "/aabout": "about",
}
export const isWork = (page: string) => !!WORK_PAGES[page]

/** Pages not rebuilt yet open on the Framer site. */
export const FALLBACK_ORIGIN = "https://www.nascimen.to"

export const clean = (p: string) => (p || "/").replace(/\/+$/, "") || "/"
export function routeForPath(path: string) {
    for (const id in ROUTES) if (clean(ROUTES[id].path) === clean(path)) return id
    return ALIASES[clean(path)]
}
